/**
 * Elite Venue Essentials — Product Page Enhancements
 * - Phone CTA below price
 * - Trust badges near Add to Cart
 * - Sticky "Call to Order / Add to Cart" bar
 * - Auto-expand description / Key Features
 */
(function () {
  'use strict';

  /* ─── Only run on product pages ─── */
  if (!window.location.pathname.includes('/products/')) return;

  /* ─── Styles ─── */
  var style = document.createElement('style');
  style.textContent = [
    /* Phone CTA banner */
    '#eve-phone-cta{margin:12px 0 16px;display:block;}',
    '#eve-phone-link{display:inline-flex;align-items:center;gap:10px;background:#1a3a2a;color:#fff;',
    'text-decoration:none;padding:12px 20px;border-radius:6px;font-size:15px;font-weight:600;',
    'transition:background .2s;width:100%;box-sizing:border-box;justify-content:center;}',
    '#eve-phone-link:hover{background:#0f2218;color:#fff;}',
    '.eve-phone-icon{font-size:18px;}',
    '.eve-phone-num{font-size:16px;}',
    '.eve-phone-hours{font-size:12px;opacity:.8;font-weight:400;}',

    /* Trust badges */
    '#eve-trust-badges{display:flex;flex-wrap:wrap;gap:8px;margin-top:14px;}',
    '.eve-badge{display:flex;align-items:center;gap:6px;font-size:12px;color:#333;',
    'background:#f5f5f0;border:1px solid #ddd;border-radius:4px;padding:5px 10px;}',

    /* Sticky bar */
    '#eve-sticky-bar{position:fixed;bottom:0;left:0;right:0;z-index:9999;',
    'background:#fff;border-top:2px solid #1a3a2a;box-shadow:0 -2px 12px rgba(0,0,0,.15);',
    'padding:10px 16px;display:none;}',
    '#eve-sticky-bar.eve-visible{display:block;}',
    '#eve-sticky-inner{max-width:1200px;margin:0 auto;display:flex;',
    'align-items:center;justify-content:space-between;gap:12px;}',
    '#eve-sticky-product{flex:1;min-width:0;}',
    '#eve-sticky-title{display:block;font-size:13px;font-weight:600;',
    'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
    '#eve-sticky-price{display:block;font-size:13px;color:#555;}',
    '#eve-sticky-actions{display:flex;gap:10px;flex-shrink:0;}',
    '#eve-sticky-call{display:flex;align-items:center;gap:6px;background:#1a3a2a;color:#fff;',
    'text-decoration:none;padding:10px 16px;border-radius:5px;font-size:14px;font-weight:600;',
    'white-space:nowrap;}',
    '#eve-sticky-call:hover{background:#0f2218;}',
    '#eve-sticky-atc{background:#8b6914;color:#fff;border:none;cursor:pointer;',
    'padding:10px 20px;border-radius:5px;font-size:14px;font-weight:600;white-space:nowrap;}',
    '#eve-sticky-atc:hover{background:#6d520f;}',
    '@media(max-width:600px){',
    '#eve-sticky-title{display:none;}',
    '#eve-sticky-actions{flex:1;}',
    '#eve-sticky-call,#eve-sticky-atc{flex:1;justify-content:center;text-align:center;}',
    '}'
  ].join('');
  document.head.appendChild(style);

  /* ─── Helpers ─── */
  function waitFor(selector, callback, maxMs) {
    var found = document.querySelector(selector);
    if (found) { callback(found); return; }
    var deadline = Date.now() + (maxMs || 5000);
    var id = setInterval(function () {
      var el = document.querySelector(selector);
      if (el) { clearInterval(id); callback(el); }
      else if (Date.now() > deadline) { clearInterval(id); }
    }, 150);
  }

  /* ─── 1. Phone CTA ─── */
  function addPhoneCTA() {
    /* Try multiple selectors — Charge theme price area */
    var candidates = [
      '.product-main__price',
      '.product__price-wrapper',
      '.price-wrapper',
      '.price__container',
      '[class*="price-wrapper"]',
      '[class*="product__price"]'
    ];
    var target = null;
    for (var i = 0; i < candidates.length; i++) {
      target = document.querySelector(candidates[i]);
      if (target) break;
    }
    if (!target) {
      /* Fall back: find the first price element */
      target = document.querySelector('.price');
    }
    if (!target) return;

    var banner = document.createElement('div');
    banner.id = 'eve-phone-cta';
    banner.innerHTML =
      '<a href="tel:2705820677" id="eve-phone-link">' +
      '<span class="eve-phone-icon">📞</span>' +
      '<span class="eve-phone-num">Questions? Call <strong>(270)-582-0677</strong></span>' +
      '<span class="eve-phone-hours">Mon–Fri, 8am–5pm CT</span>' +
      '</a>';

    var ref = target.parentNode;
    ref.insertBefore(banner, target.nextSibling);
  }

  /* ─── 2. Trust Badges ─── */
  function addTrustBadges() {
    var atcSelectors = [
      'button[name="add"]',
      '.product-form__submit',
      '.product-form__cart-submit',
      'button[type="submit"][class*="product"]',
      'form[action="/cart/add"] button[type="submit"]'
    ];
    var atcBtn = null;
    for (var i = 0; i < atcSelectors.length; i++) {
      atcBtn = document.querySelector(atcSelectors[i]);
      if (atcBtn) break;
    }
    if (!atcBtn) return;

    /* Find a suitable parent container */
    var container = atcBtn.closest('form') || atcBtn.parentNode;

    var badges = document.createElement('div');
    badges.id = 'eve-trust-badges';
    badges.innerHTML =
      '<div class="eve-badge">✅ Price Match Guarantee</div>' +
      '<div class="eve-badge">🛡️ Product Quality Guarantee</div>' +
      '<div class="eve-badge">🚚 Free Shipping Available</div>' +
      '<div class="eve-badge">💳 Financing from $' + getMonthlyPayment() + '/mo</div>';

    container.appendChild(badges);
  }

  function getMonthlyPayment() {
    try {
      var priceEl = document.querySelector('.price__current, .price-item--regular, [class*="price__current"]');
      if (!priceEl) return '0';
      var txt = priceEl.innerText.replace(/[^0-9.]/g, '');
      var num = parseFloat(txt);
      if (isNaN(num) || num <= 0) return '0';
      return Math.round(num / 12).toLocaleString();
    } catch (e) { return '0'; }
  }

  /* ─── 3. Sticky Bar ─── */
  function addStickyBar() {
    var bar = document.createElement('div');
    bar.id = 'eve-sticky-bar';

    var title = (document.querySelector('h1') || {}).innerText || '';
    title = title.length > 45 ? title.substring(0, 42) + '…' : title;

    var priceEl = document.querySelector('.price__current, .price-item--regular, [class*="price__current"]');
    var priceText = priceEl ? priceEl.innerText.trim() : '';

    bar.innerHTML =
      '<div id="eve-sticky-inner">' +
      '<div id="eve-sticky-product">' +
      '<span id="eve-sticky-title">' + title + '</span>' +
      '<span id="eve-sticky-price">' + priceText + '</span>' +
      '</div>' +
      '<div id="eve-sticky-actions">' +
      '<a href="tel:2705820677" id="eve-sticky-call">📞 Call to Order</a>' +
      '<button id="eve-sticky-atc" type="button">Add to Cart</button>' +
      '</div>' +
      '</div>';

    document.body.appendChild(bar);

    /* Show/hide based on ATC button visibility */
    var atcBtn = null;
    function findATC() {
      var sel = ['button[name="add"]', '.product-form__submit', 'form[action="/cart/add"] button[type="submit"]'];
      for (var i = 0; i < sel.length; i++) {
        var b = document.querySelector(sel[i]);
        if (b) return b;
      }
      return null;
    }

    function onScroll() {
      if (!atcBtn) atcBtn = findATC();
      if (!atcBtn) return;
      var rect = atcBtn.getBoundingClientRect();
      var belowFold = rect.bottom < 0 || rect.top > window.innerHeight;
      bar.classList.toggle('eve-visible', belowFold);
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    /* Sticky "Add to Cart" click proxies to actual ATC */
    bar.querySelector('#eve-sticky-atc').addEventListener('click', function () {
      if (!atcBtn) atcBtn = findATC();
      if (atcBtn) {
        atcBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { if (atcBtn) atcBtn.click(); }, 600);
      }
    });
  }

  /* ─── 4. Expand "...more" / collapsed descriptions ─── */
  function expandDescriptions() {
    /* Charge theme uses <text-expandable> web component.
       Setting data-expanded="true" triggers the CSS expansion.
       The component's toggleDescription() needs a real event, so we
       set the dataset attribute directly and update button visibility. */
    function doExpand() {
      var els = document.querySelectorAll('text-expandable');
      if (!els.length) return false;
      els.forEach(function (el) {
        el.dataset.expanded = 'true';
        var expandBtn = el.querySelector('.expand');
        var narrowBtn = el.querySelector('.narrow');
        if (expandBtn) expandBtn.style.visibility = 'hidden';
        if (narrowBtn) narrowBtn.removeAttribute('hidden');
      });
      return true;
    }

    if (!doExpand()) {
      /* If web component not yet in DOM, poll for it */
      var deadline = Date.now() + 5000;
      var id = setInterval(function () {
        if (doExpand() || Date.now() > deadline) clearInterval(id);
      }, 200);
    }
  }

  /* ─── Init ─── */
  function run() {
    expandDescriptions();
    addPhoneCTA();

    /* ATC-dependent items — wait for button to be in DOM */
    waitFor('button[name="add"], .product-form__submit', function () {
      addTrustBadges();
      addStickyBar();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

})();
